import axios from 'axios';
import { BaseURL } from '../common/constants/urlconst';
import commonLabels from  '../common/labels/commonLabels.json';

import { decryptData, encryptData, generateCRC } from '../common/actions/commonActions';
import { toastr } from 'react-redux-toastr';
import { SESSION_HEARTBEAT } from '../admin/common/constants/endpoints';
const API = axios.create({
    // baseURL: BaseURL,
    headers: {
        'Content-Type': 'application/json',
    },
    responseType: "json"
});
API.interceptors.request.use(
    (config) => {
        if (config.url.includes("/web/api/v1/otps/")) {
            const crc = generateCRC(config);
            config.headers.Authorization = `|#|#${crc}`;
            return config;
        }
      
        let token = sessionStorage.getItem("token");
        if (token) {
            if(config.url.replace(/\/\d+$/, "") === SESSION_HEARTBEAT){
                config.headers['Authorization'] = `Bearer ${token}`;
            }else{
                config.headers.Authorization = `Bearer ${token}|#|#${generateCRC(config)}`;
            }
        }
        else{
            config.headers.Authorization = `|#|#${generateCRC(config)}`;
        }
        
        
        // if (config.headers['Content-Type'] === 'multipart/form-data') {
        //     return config;
        // }

       
        // config.headers['Access-Control-Allow-School'] = generateCRC();

        // config.headers['access-control-allow-web'] = generateCRC(config);

        if (config.method !== 'get' && config.data && !config.data.encryptedReqBody && config.headers['Content-Type'] !== 'multipart/form-data') {
            // config.headers.Authorization = `|#|#${generateCRC()}`;
            config.data = { encryptedReqBody: encryptData(JSON.stringify(config.data)) };
        }
        return config;
    },
    (error) => Promise.reject(error)
);

API.interceptors.response.use(
    (response) => {
        // if (response.config.url.includes("/web/api/v1/otps/")) {

        //     return response;
        // }
        if (response.config.url.includes("/web/api/v1/otps/")) {
            const crc = generateCRC(response);
            response.headers.Authorization = `|#|#${crc}`;
            return response;
        }
        let copyResponse =response
        try{
            copyResponse.data = JSON.parse(decryptData(copyResponse.data));
        }catch{
            copyResponse.data = copyResponse.data
        }
        //old crc res logic

        // copyResponse.data =JSON.parse(decryptData(copyResponse.data))
        const generatedCRCVal =generateCRC(copyResponse)
        let accessControlAllowWeb = response.headers["access-control-allow-web"];

        // new crc res logic
        let AuthorizationVal = response.headers["authorization"];
        if (!AuthorizationVal && response.config.url.includes("/web/api/v1/otps")) {
            return response; 
        }
        const backendCrcValue = AuthorizationVal.split("|#|#")[1];

        // if(generatedCRCVal == accessControlAllowWeb){
        if(response.config.url.replace(/\/\d+$/, "") === SESSION_HEARTBEAT){
            return response;
        }
        if(generatedCRCVal == backendCrcValue){
            if (response.data && !(response.config.headers['Content-Type'] && response.config.headers['Content-Type'].includes('multipart/form-data'))) {
            try{
                response.data = JSON.parse(decryptData(response.data));
            }catch{
                response.data = response.data
            }
        }
            

        return response;
        }else{
            toastr.error(commonLabels.CRC_VALUE_NOT_MATCH)
            return Promise.reject(response);

        }
        
    },
    (error) => {
  if (error.response) {
    if (error.config?.url?.includes("/web/api/v1/otps")) {
      return Promise.reject(error);
    }

    console.error("API Error:", error.response);
  }
  return Promise.reject(error);
}
);
export default API;